/* ============================================================
   SOLVEY · Inline language switcher controller
   ------------------------------------------------------------
   Handles multiple instances of snippets/solvey-language-switcher
   on the page (desktop header + mobile header + drawer fallback).

   Wires up:
   - Click op trigger → toggle dropdown open/close
   - Klik op andere taal-optie → Weglot.switchTo(lang) (of nav-fallback)
   - Outside click / Escape / scroll → close
   - Sync current-language label (vlag + 2-letter code) met Weglot's
     huidige taal of <html lang>.
   ============================================================ */
(function () {
  'use strict';

  var LANG_META = {
    nl: { code: 'NL', label: 'Nederlands' },
    en: { code: 'EN', label: 'English' },
    de: { code: 'DE', label: 'Deutsch' }
  };

  var FLAG_SVG = {
    nl:
      '<svg viewBox="0 0 18 12" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<rect width="18" height="4" y="0" fill="#AE1C28"/>' +
      '<rect width="18" height="4" y="4" fill="#FFFFFF"/>' +
      '<rect width="18" height="4" y="8" fill="#21468B"/>' +
      '</svg>',
    en:
      '<svg viewBox="0 0 18 12" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<defs><clipPath id="solvey-flag-en-js-clip"><rect width="18" height="12"/></clipPath></defs>' +
      '<g clip-path="url(#solvey-flag-en-js-clip)">' +
      '<rect width="18" height="12" fill="#012169"/>' +
      '<path d="M0 0 L18 12 M18 0 L0 12" stroke="#FFFFFF" stroke-width="2.4"/>' +
      '<path d="M0 0 L18 12 M18 0 L0 12" stroke="#C8102E" stroke-width="1.2"/>' +
      '<path d="M9 0 V12 M0 6 H18" stroke="#FFFFFF" stroke-width="3.6"/>' +
      '<path d="M9 0 V12 M0 6 H18" stroke="#C8102E" stroke-width="2.1"/>' +
      '</g></svg>',
    de:
      '<svg viewBox="0 0 18 12" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<rect width="18" height="4" y="0" fill="#000000"/>' +
      '<rect width="18" height="4" y="4" fill="#DD0000"/>' +
      '<rect width="18" height="4" y="8" fill="#FFCE00"/>' +
      '</svg>'
  };

  var DEV_HOSTS = /^(127\.0\.0\.1|localhost|0\.0\.0\.0)$/;

  function currentLang() {
    try {
      if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') {
        var wl = window.Weglot.getCurrentLang();
        if (wl) return wl;
      }
    } catch (e) {}
    var html = document.documentElement.getAttribute('lang') || 'nl';
    return (html.split('-')[0] || 'nl').toLowerCase();
  }

  function closeAll(exception) {
    document.querySelectorAll('[data-solvey-lang-switch]').forEach(function (root) {
      if (root === exception) return;
      setOpen(root, false);
    });
  }

  function setOpen(root, open) {
    root.classList.toggle('is-open', open);
    var trigger = root.querySelector('[data-solvey-lang-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* Welke talen biedt Weglot daadwerkelijk aan? Zolang een taal nog niet in
     het Weglot-dashboard is aangezet, verbergen we de optie — anders krijg je
     een knop die niets doet. Kan Weglot het niet vertellen, dan tonen we alles
     (liever een optie te veel dan een lege switcher). */
  function availableLangs() {
    try {
      if (window.Weglot && typeof window.Weglot.getAvailableLanguages === 'function') {
        var list = window.Weglot.getAvailableLanguages();
        if (list && list.length) {
          var out = list.slice();
          var from = window.Weglot.options && window.Weglot.options.language_from;
          if (from && out.indexOf(from) < 0) out.push(from);
          return out;
        }
      }
    } catch (e) {}
    return null;
  }

  function syncCurrent(root) {
    var lang = currentLang();
    var avail = availableLangs();
    if (avail) {
      root.querySelectorAll('[data-solvey-lang]').forEach(function (opt) {
        var l = opt.getAttribute('data-solvey-lang');
        var li = opt.closest('li') || opt;
        li.hidden = avail.indexOf(l) < 0 && l !== lang;
      });
    }
    var meta = LANG_META[lang] || LANG_META.nl;
    var flag = root.querySelector('[data-solvey-lang-current-flag]');
    var code = root.querySelector('[data-solvey-lang-current-code]');
    if (flag) flag.innerHTML = FLAG_SVG[lang] || FLAG_SVG.nl;
    if (code) code.textContent = meta.code;
    root.querySelectorAll('[data-solvey-lang]').forEach(function (opt) {
      var isActive = opt.getAttribute('data-solvey-lang') === lang;
      opt.classList.toggle('is-active', isActive);
      opt.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function switchTo(lang) {
    if (!lang) return;
    if (window.Weglot && typeof window.Weglot.switchTo === 'function') {
      window.Weglot.switchTo(lang);
      return;
    }
    // Fallback (no Weglot loaded yet): build subdirectory URL.
    var path = window.location.pathname.replace(/^\/(nl|en|de|da)(\/|$)/, '/');
    if (lang !== 'nl') path = '/' + lang + path;
    window.location.href = path + window.location.search + window.location.hash;
  }

  function attach(root) {
    if (root.dataset.solveyLangInit === '1') return;
    root.dataset.solveyLangInit = '1';

    var trigger = root.querySelector('[data-solvey-lang-trigger]');
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var willOpen = !root.classList.contains('is-open');
        closeAll(root);
        setOpen(root, willOpen);
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var willOpen = !root.classList.contains('is-open');
          closeAll(root);
          setOpen(root, willOpen);
        } else if (e.key === 'Escape') {
          setOpen(root, false);
        }
      });
    }

    root.querySelectorAll('[data-solvey-lang]').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var lang = opt.getAttribute('data-solvey-lang');
        setOpen(root, false);
        switchTo(lang);
      });
    });

    syncCurrent(root);
  }

  /* De originele Weglot-pill staat in custom.css op het sr-only-patroon
     (1px, clip-rect). Dat verbergt hem visueel maar houdt hem BEWUST in de
     tab-volgorde en de screenreader-output — dat is precies wat sr-only
     doet. Hier is dat verkeerd: deze switcher is vervangen door de eigen
     pill hierboven, dus een toetsenbordgebruiker tabt door een schakelaar
     die hij niet ziet (gemeten: 2px breed, tabindex="0"), en een
     screenreader kondigt twee taalschakelaars aan.

     We halen hem uit de a11y-boom en uit de tab-volgorde, maar laten het
     DOM-element staan: Weglot's motor heeft die node nodig en wij roepen
     switchTo() er nog steeds op aan. display:none zou de motor breken. */
  function muteWeglotSwitcher() {
    document.querySelectorAll('.weglot_switcher, .country-selector, .wg-drop, #weglot_here').forEach(function (root) {
      if (root.getAttribute('aria-hidden') !== 'true') root.setAttribute('aria-hidden', 'true');
      root.querySelectorAll('a, button, [tabindex]').forEach(function (el) {
        if (el.getAttribute('tabindex') !== '-1') el.setAttribute('tabindex', '-1');
      });
    });
  }

  function attachAll() {
    document.querySelectorAll('[data-solvey-lang-switch]').forEach(attach);
    muteWeglotSwitcher();
  }

  function init() {
    attachAll();

    // Outside click closes all open switchers.
    document.addEventListener('pointerdown', function (e) {
      document.querySelectorAll('[data-solvey-lang-switch].is-open').forEach(function (root) {
        if (!root.contains(e.target)) setOpen(root, false);
      });
    }, true);

    // Scroll / resize close.
    var closeOnScroll = function () { closeAll(null); };
    window.addEventListener('scroll', closeOnScroll, { passive: true });
    window.addEventListener('resize', closeOnScroll);

    // Escape closes + returns focus.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-solvey-lang-switch].is-open').forEach(function (root) {
        setOpen(root, false);
        var trigger = root.querySelector('[data-solvey-lang-trigger]');
        if (trigger && typeof trigger.focus === 'function') trigger.focus();
      });
    });

    // Resync current language when Weglot finishes loading.
    if (window.Weglot && typeof window.Weglot.on === 'function') {
      try {
        window.Weglot.on('languageChanged', function () {
          document.querySelectorAll('[data-solvey-lang-switch]').forEach(syncCurrent);
        });
        window.Weglot.on('initialized', function () {
          document.querySelectorAll('[data-solvey-lang-switch]').forEach(syncCurrent);
        });
      } catch (e) {}
    } else {
      // Poll briefly for Weglot to appear.
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (window.Weglot && typeof window.Weglot.on === 'function') {
          clearInterval(t);
          try {
            window.Weglot.on('languageChanged', function () {
              document.querySelectorAll('[data-solvey-lang-switch]').forEach(syncCurrent);
            });
          } catch (e) {}
          document.querySelectorAll('[data-solvey-lang-switch]').forEach(syncCurrent);
        } else if (tries > 40) {
          clearInterval(t);
        }
      }, 250);
    }

    // Re-attach if header re-renders (sticky transitions clone DOM in some themes).
    var obs = new MutationObserver(function () { attachAll(); });
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
